import { ISubjectNotification } from '../../../ApiPackage/SearchModule/interfaces/ISubjectNotification';
import { KnmSubtitle } from './KnmSubtitle';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from '../../../CorePackage/MainModule/constants/dateFormat';
import styles from './styles.module.scss';

interface ISubjectNotificationsProps {
  subjectNotifications: ISubjectNotification[] | undefined;
  isPm?: boolean;
}

export const SubjectNotifications = ({ subjectNotifications, isPm }: ISubjectNotificationsProps) => {
  if (!subjectNotifications || subjectNotifications.length === 0) {
    return null;
  }

  return (
    <KnmSubtitle title={`Информация об уведомлении проверяемого лица о проведении ${isPm ? 'ПМ' : 'КНМ'}`}>
      {subjectNotifications.map((item, index) => (
        <div key={index}>
          <div className={styles.SectionTitle}>Уведомление #{index + 1}</div>
          {item.type?.name && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Способ уведомления</div>
              <div className={styles.ColValue}>{item.type.name}</div>
            </div>
          )}
          {item.date && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Дата уведомления</div>
              <div className={styles.ColValue}>{formatDate({ date: item.date, dateFormat: DATE_FORMAT_LONG })}</div>
            </div>
          )}
          {item.comment && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Примечание</div>
              <div className={styles.ColValue}>{item.comment}</div>
            </div>
          )}
        </div>
      ))}
    </KnmSubtitle>
  );
};
